import React, { useState } from "react";
import "./faq.scss";
import Header from "../../components/Header/Header";
import investmentFAQ from "./investmentAns";
import phylanFAQ from "./phylanAns";

const Faq = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [questionid, setquestionid] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("Investment");

  document.title = "FAQs | Ballers";

  const toggleAnswer = (prop) => {
    setIsOpen(!isOpen);
    setquestionid(prop);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setIsOpen(false); // Close any open answers when switching categories
  };

  const faqData = selectedCategory === "Investment" ? investmentFAQ : phylanFAQ;

  return (
    <div className="faq_section">
      <div className="faq_content">
        {/* Pass the selectedCategory to the Header as a prop */}
        <Header selectedCategory={selectedCategory} />
        <div className="faqsection">
          <div className="faq_question">
            <ol>
              {faqData.map((question) => (
                <div
                  onClick={() => toggleAnswer(question.id)}
                  key={question.id}
                  className="singlequestion"
                >
                  <div>
                    <li>{question.question}</li>
                    {isOpen && question.id === questionid && (
                      <div className="answer">{question.answer}</div>
                    )}
                  </div>
                  <span>
                    {isOpen && question.id === questionid ? "-" : "+"}
                  </span>
                </div>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
